
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `ចុចលើ "បើកក្នុងកម្មវិធីរុករក..."`,
's182ab2d6c997515f': `បន្ថែមវាទៅកាន់ផ្ទាំងអេក្រង់ដើមដើម្បីទទួលបាននូវបទពិសោធន៍កាន់តែល្អនិងងាយស្រួលប្រើ។`,
's224cbcec014ef6b5': `ចុចលើ ប៊ូតុងចែករំលែក នៅក្នុងរបារទិសដៅ`,
's233af3b7eb5e0364': `បន្ថែមទៅទំព័រដើម`,
's37a9e8aec5713460': `បង្ហាញបន្ថែម`,
's4c3161035f3a1413': `ចុចលើ ម៉ឺនុយ`,
's4e1e10a6ca408245': `ចុចលើ "បន្ថែមទៅកាន់ផ្ទាំងអេក្រង់ដើម"`,
's6196153c4b0c1ea0': `តំឡើង`,
's633502f7cff4f847': `បើកម៉ឺនុយកម្មវិធីរុករករបស់អ្នក`,
's681e399d63311fba': `បង្ហាញវិចិត្រសាល`,
's6d14a4f70ba4e3cf': `ចុចលើ ម៉ឺនុយ ប្រសិនបើគ្មានរូបសញ្ញា ចែករំលែក`,
's922329d6f6213590': `បន្ថែមទៅកាន់ Dock`,
's9c63a79ffcc2a3a3': `ចុចលើ "បន្ថែមទៅកាន់ផ្ទាំងអេក្រង់ដើម"`,
'sa2d71bfd9525168d': `ចុចលើ "បន្ថែមទៅកាន់ Dock"`,
'sa5ef80b4bb9b39f8': `បង្ហាញតិច`,
'sb527eca1c1d7e7be': `បើកម៉ឺនុយកម្មវិធីរុករកក្នុងកម្មវិធី`,
'sba52286c21552a4e': `តំឡើងវានៅលើឧបករណ៍របស់អ្នកដើម្បីទទួលបាននូវបទពិសោធន៍កាន់តែល្អនិងងាយស្រួលប្រើ។`,
'sc16e00a7a8b2fde2': `ត្រឡប់ក្រោយ`,
'scdaf4bbff76674c8': `បន្ថែមទៅកាន់ផ្ទាំងអេក្រង់ដើម`,
'sd18a5b85f599ff3c': `បើកតំណដែលបានចម្លងនៅក្នុង Safari`,
'se72fc3a84f9b51c3': `ចុចដើម្បីចម្លងតំណ`,
'se740f75b95a51807': `បន្ថែមវាទៅកាន់ Dock ដើម្បីទទួលបាននូវបទពិសោធន៍កាន់តែល្អនិងងាយស្រួលប្រើ។`,
'sfa6c42cdf48d93d2': `ប៉ុន្តែកម្មវិធីរុករកនេះមិនគាំទ្រមុខងារនេះទេ។ ដើម្បីបន្ត សូមបើកតំណនៅក្នុងកម្មវិធីរុករកខាងក្រៅ។`,
'sfb78526365796a41': `ចុចលើ "បង្ហាញបន្ថែម" នៅក្នុងម៉ឺនុយចែករំលែក`,
'sfea652f6580ff086': `គេហទំព័រនេះមានមុខងារជាកម្មវិធី។`,
    };
  